import { handleInitialInterestError } from '../hubspot-forms/handleInitialInterestResponse';
import { initialInterest } from '../hubspot-forms/initialInterest';
import { SignupInterestActionTypes } from '../store/signup-interest/action-types';
import { EndpointKey } from './EndpointKey';
import { isDACHCountry } from '../gdpr/gdprUtils';
export const EndpointsSignupInterest = {
  [EndpointKey.InitialInterest]: {
    once: true,
    stateCheck: state => !isDACHCountry(state),
    method: initialInterest,
    handleError: handleInitialInterestError,
    reduxActionType: SignupInterestActionTypes.SubmitForm
  }
};